function stubFalse() {
  return !1;
}
export {
  stubFalse as default
};
//# sourceMappingURL=stubFalse.js.map
